import { useMutation } from "@apollo/client";

import {
  CreateRecurringDepositMutation,
  CreateRecurringDepositMutationVariables,
  TransactionTime,
} from "@ctypes";
import { CREATE_SIP, TRANSACTIONS, USER } from "@graphql";
import { DEFAULT_SIZE } from "@hooks/transfers";

export const useCreateSip = () => {
  return useMutation<CreateRecurringDepositMutation, CreateRecurringDepositMutationVariables>(
    CREATE_SIP,
    {
      refetchQueries: [
        USER,
        {
          query: TRANSACTIONS,
          variables: {
            size: DEFAULT_SIZE,
            time: TransactionTime.Upcoming,
          },
        },
      ],
      awaitRefetchQueries: true,
    },
  );
};
